// extracted by mini-css-extract-plugin
export default {"container":"MagazineCarousel_container__i+MYa","carousel":"MagazineCarousel_carousel__sMJ0l"};